/**
 * Created with IntelliJ IDEA.
 * User: itkoren
 * Date: 07/20/13
 * Time: 11:41 AM
 * To change this template use File | Settings | File Templates.
 */
// <editor-fold desc="AMD Wrapper">
define(function (require) {
    "use strict";

    // <editor-fold desc="Dependencies">
    // Yep I'll need underscore here
    var _ = require("underscore");

    // Get backbone
    var Backbone = require("backbone");

    // Get the wreqr
    var Wreqr = require("backbone.wreqr");

    var Logger = require("logger");

    var LPCourier = require("Chronos.PostMessageCourier");

    var logger = Logger.getLogger("media");
    // </editor-fold desc="Dependencies">

    // <editor-fold desc="Declaration">
    // This is the different communication means constructors
    var construct = {
          vent: Wreqr.EventAggregator
        , commands: Wreqr.Commands
        , reqres: Wreqr.RequestResponse
        , channel: Channel
    };

    // This is the prototypes we are dealing with to override with better exception handling
    var prototypes = {
          events: Backbone.Events
        , me: Backbone.Model.prototype
        , ce: Backbone.Collection.prototype
        , ve: Backbone.View.prototype
        , re: Backbone.Router.prototype
        , he: Backbone.History.prototype
        , ea: Wreqr.EventAggregator.prototype
        , handlers: Wreqr.Handlers.prototype
        , commands: Wreqr.CommandStorage.prototype
    };

    // The means of communications
    var means = {
          vent: "vent"
        , commands: "commands"
        , reqres: "reqres"
    };

    // The available actions
    var actions = {
          trigger: "trigger"
        , command: "command"
        , request: "request"
    };

    // The default API's to override with better exception handling
    // Each prototype which does not have a concrete configuration (defined in concreteTryCatchApisToWrap) will be using this
    // NOTE: The numeric value represents the index of the callback in the arguments of the method
    var defaultTryCatchApisToWrap = {
          on: 1
    };

    // Concrete prototype configuration for The API's we would like to override with better exception handling
    // NOTE: The numeric value represents the index of the callback in the arguments of the method
    var concreteTryCatchApisToWrap = {
          handlers: {
                on: 1
              , setHandler: 1
          }
    };

    // These are the methods I want to proxy per communication mean
    var messageMeans = {
        vent: [
              "on"
            , "off"
            , "bind"     // Alias for for backwards compatibility
            , "unbind"   // Alias for for backwards compatibility
            , "trigger"
            , "once"
            , "stopListening"
            , "listenTo"
            , "listenToOnce"
        ],

        commands: [
              "execute"
            , "setHandler"
            , "setHandlers"
            , "removeHandler"
            , "removeAllHandlers"
        ],

        reqres: [
              "request"
            , "setHandler"
            , "setHandlers"
            , "removeHandler"
            , "removeAllHandlers"
        ]
    };

    var channelAliases = {
          vent: {
                on: "on"
              , off: "off"
              , bind: "bind"       // Alias for for backwards compatibility
              , unbind: "unbind"   // Alias for for backwards compatibility
              , trigger: "send"
              , once: "once"
              , stopListening: "stopListening"
              , listenTo: "listenTo"
              , listenToOnce: "listenToOnce"
          }
        , commands: {
              command: "send"
            , comply: "setHandler"
            , stopComplying: "removeHandler"
          }
        , reqres: {
              request: "send"
            , reply: "setHandler"
            , stopReplying: "removeHandler"
          }
    };

    // I would like to create a generic communication method for all communication means
    // I'll wrap all concrete functions with a send method
    var send = {
          vent: "trigger"
        , commands: "execute"
        , reqres: "request"
    };
    // </editor-fold desc="Declaration">

    // <editor-fold desc="Invocation">
    // First lets override backbone events api's to implement an improved exception handling
    // I am deliberately overriding on, off & once in order to wrap the callback with try/catch and not the trigger api itself
    // Since backbone is using a private method for calling the handler itself
    //>>excludeStart("developmentPhase", pragmas.developmentPhase);
    if (false) { // Do Not Handle Exceptions at Development
        //>>excludeEnd("developmentPhase");
        _improveBackboneEventsExceptionHandling();
        //>>excludeStart("developmentPhase", pragmas.developmentPhase);
    }
    //>>excludeEnd("developmentPhase");
    // </editor-fold desc="Invocation">

    // <editor-fold desc="Public Methods">
    // Just the pure constructor for our channel (which is based on the Wreqr channel)
    function Channel(name) {
        this.channel = Wreqr.radio.channel(name);
        this.vent = {};
        this.commands = {};
        this.reqres = {};
        this.onlyOnce = {
              commands: {}
            , reqres: {}
        };

        _proxyChannel(this);
    }

    // Lets create a factory for all communication means
    var _factory = {
          vent: function() {
              return new construct.vent();
          }
        , commands: function() {
              return new construct.commands();
          }
        , reqres: function() {
              return new construct.reqres();
          }
        , channel: function(name) {
              return new construct.channel(name);
          }
    };

    // And here are some factories/wrappers for ease of use:

    function channel(name) {
        return new Channel(name);
    }

    function mean(type, channelName) {
        if (channelName) {
            return channel(channelName)[type];
        }
        else {
            var src = _factory[type]();
            var target = {};

            _proxyMean(type, src, target);

            return target;
        }
    }

    function vent(channelName) {
        return mean(means.vent, channelName);
    }

    function commands(channelName) {
        return mean(means.commands, channelName);
    }

    function reqres(channelName) {
        return mean(means.reqres, channelName);
    }

    function isMean(mean, type) {
        return mean instanceof construct[type];
    }

    function isVent(mean) {
        return isMean(mean, means.vent);
    }

    function isCommands(mean) {
        return isMean(mean, means.commands);
    }

    function isReqRes(mean) {
        return isMean(mean, means.reqres);
    }

    function isChannel(mean) {
        return isMean(mean, "channel");
    }

    function getMediaForContext(context) {
        var prefix = context + ".";

        return {
            channel: function(name) {
                return channel(prefix + name);
            }
        };
    }
    // </editor-fold desc="Public Methods">

    // <editor-fold desc="Private Methods">
    // Wraps a method with try/catch block
    function _tryCatchWrap(callback, name, context) {
        return function() {
            try {
                // Call the original trigger API
                return callback.apply(context || this, [].slice.apply(arguments));
            }
            catch(ex) {
                logger.error("Media >> tryCatchWrap >> " + name + " >> error >> ex=" + ex, "", ex);
            }
        };
    }

    // Override a specific Backbone/Wreqr API with method which wraps the callback it receives with a try/catch block
    function _overrideMethodWithExceptionHandling(proto, method, callbackIndex) {
        var orgApi = proto[method];

        if (orgApi) {
            proto[method] = function() {
                // Get the arguments
                var args = [].slice.apply(arguments);

                // Get the original callback
                var callback = args[callbackIndex];

                // Only if we have a valid callback/handler
                if (callback) {
                    // Wrap the callback with try/catch block
                    args[callbackIndex] = _tryCatchWrap(callback, method);

                    // Save the original callback reference for further usage of backbone - This will allow the off method to resolve the original callback
                    args[callbackIndex]._callback = callback._callback || callback;
                }

                orgApi.apply(this, args);
            };
        }
    }

    // Iterates over a specified prototype (Backbone/Wreqr) to override the predefined methods with better exception handling
    function _overridePrototypeWithExceptionHandling(proto) {
        _.each(concreteTryCatchApisToWrap[proto] || defaultTryCatchApisToWrap, function(callbackIndex, method) {
            _overrideMethodWithExceptionHandling(prototypes[proto], method, callbackIndex);
        });
    }

    // Iterates over predefined prototypes (Backbone/Wreqr) to override the predefined methods in each with better exception handling
    function _improveBackboneEventsExceptionHandling() {
        _.each(prototypes, function(value, proto) {
            _overridePrototypeWithExceptionHandling(proto);
        });
    }

    // Invoke the wrapped method
    function _invokeMethod(mean, method, args) {
        return mean[method].apply(mean, args);
    }

    // This is the proxy method magic which will help me to proxy all methods
    function _proxyMethod(mean, method) {
        return function() {
            var args = [].slice.apply(arguments);

            return _invokeMethod(mean, method, args);
        };
    }

    function _proxyOnceMethod(mean, method, once) {
        return function() {
            var args = [].slice.apply(arguments);

            if (once) {
                once[args[0]] = true;
            }

            return _invokeMethod(mean, method, args);
        };
    }

    function _proxyOnceCheckMethod(mean, method, once) {
        return function() {
            var args = [].slice.apply(arguments);

            var result = _invokeMethod(mean, method, args);

            if (once && once[args[0]]) {
                mean.removeHandler.call(mean, args[0]);
                delete once[args[0]];
            }

            return result;
        };
    }

    // This will be the communication mean proxy logic
    function _proxyMean(mean, source, target, once) {
        _.each(messageMeans[mean], function(method) {
            target[method] = _proxyMethod(source, method);
        });

        // Now lets add the generic send method which will proxy the concrete method
        target.send = _proxyOnceCheckMethod(source, send[mean], once);
    }

    // This will be the communication channel proxy logic
    function _proxyChannel(channel) {
        _.each(messageMeans, function(methods, type) {
            _proxyMean(type, channel.channel[type], channel[type], channel.onlyOnce[type]);
        });

        _.each(channelAliases, function(aliases, mean) {
            _.each(aliases, function(target, source) {
                channel[source] = channel[mean][target];
            });
        });

        channel.complyOnce = _proxyOnceMethod(channel.channel[means.commands], "setHandler", channel.onlyOnce.commands);
        channel.replyOnce = _proxyOnceMethod(channel.channel[means.reqres], "setHandler", channel.onlyOnce.reqres);
        channel.reset = _proxyMethod(channel.channel, "reset");

        channel.destroy = function() {
            // Nullify
            delete channel.channel;
            delete channel.vent;
            delete channel.commands;
            delete channel.reqres;
            delete channel.onlyOnce;

            channel = void 0;
        };
    }
    // </editor-fold desc="Private Methods">

    // <editor-fold desc="Return Area">
    return {
          radio: Wreqr.radio
        , channel: channel
        , mean: mean
        , vent: vent
        , commands: commands
        , reqres: reqres
        , isMean: isMean
        , isVent: isVent
        , isCommands: isCommands
        , isReqRes: isReqRes
        , isChannel: isChannel
        , means: means
        , actions: actions
        , getMediaForContext: getMediaForContext
        , LPCourier: LPCourier
    };
    // </editor-fold desc="Return Area">
});
// </editor-fold desc="AMD Wrapper">